module.exports = __webpack_public_path__ + "static/media/icons-tm-add-user.580f5434.svg";